// extracted by mini-css-extract-plugin
export var container = "_4d-0";
export var icon = "_4d-1";
export var text = "_4d-2";